module.exports = __webpack_public_path__ + "static/media/principles-of-econ-enrolled.fce10f33.svg";